// eslint-disable-next-line max-len
var TIME_LOCATION_MAP_ROUTE = 'M24.06,1.18l-.52.43-6.6,5.48L7.13,2.86,0,6.35V30.82l8.21-4,9.07,1.9,6.92-3.95L32,28.7V5.43Zm.08,21.34L17,26.63,8,24.74,2,27.63V7.6L7.18,5.06l10.1,4.35,7-5.83L30,6.63V25.46ZM10,8.61V23.12a1,1,0,1,1-2,0V8.61a1,1,0,0,1,2,0Zm8.11,3.66v11.4a1,1,0,0,1-2,0V12.27a1,1,0,0,1,2,0Zm7.89-5V20.73a1,1,0,1,1-2,0V7.25a1,1,0,0,1,2,0Z';

export { TIME_LOCATION_MAP_ROUTE };
//# sourceMappingURL=TIME_LOCATION_MAP_ROUTE.js.map
